// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ccjg8","top":"styles_top__Omago"};